import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// "ResizeObserver loop completed with undelivered notifications" es un aviso
// inofensivo del navegador (pasa cuando un Popover/Select se remide durante
// una animación) — no es un error de la app, pero el overlay de desarrollo
// lo muestra como si tronara. Se detiene antes de que llegue a ese overlay.
window.addEventListener("error", (e) => {
  if (
    e.message === "ResizeObserver loop completed with undelivered notifications." ||
    e.message === "ResizeObserver loop limit exceeded"
  ) {
    e.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
